import React, { Fragment, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { showModal } from '../../../../actions/modal';

import { getProductImageUrl } from '../../../../helpers';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import update from 'immutability-helper';
import Backend from 'react-dnd-html5-backend';

const Product = (props) => {
  const { data, index, moveFilter, handleRemoveProduct, handleUpdateProducts, currentProducts } =
    props;
  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: 'filter',
    drop: () => handleUpdateProducts(currentProducts), //fix
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveFilter(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'filter', data, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drag(drop(ref));

  return (
    <tr key={index} ref={ref} style={{ cursor: `grab` }}>
      <td>
        <i className="fe-align-justify" />
      </td>
      <td style={{ width: '76px' }}>
        <div
          className="image-block"
          style={{ backgroundImage: `url(${getProductImageUrl(data, 100)})` }}
        />
      </td>
      <td>{data.shortName}</td>
      <td style={{ fontSize: '16px', textAlign: 'right', cursor: 'pointer' }}>
        <i className="fe-trash-2" onClick={() => handleRemoveProduct(data.id)} />
      </td>
    </tr>
  );
};

const ManualItems = (props) => {
  const { currentProducts, handleUpdateProducts } = props;
  const dispatch = useDispatch();

  const handleAddProducts = () => {
    dispatch(
      showModal('AddingProducts', {
        title: 'Добавление товаров в коллекцию',
        buttonText: 'Добавить товары в коллекцию',
        onProductsAdding: (result) => {
          const newProducts = result.filter((p) => !currentProducts.find((cp) => cp.id === p.id));
          handleUpdateProducts([...currentProducts, ...newProducts]);
        },
      }),
    );
  };

  const handleRemoveProduct = (productId) => {
    const currentIndex = currentProducts.findIndex((p) => p.id === productId);
    if (currentIndex > -1) {
      const newProducts = currentProducts.slice();
      newProducts.splice(currentIndex, 1);
      handleUpdateProducts(newProducts);
    }
  };

  const moveFilter = useCallback(
    (dragIndex, hoverIndex) => {
      const dragCard = currentProducts[dragIndex];
      handleUpdateProducts(
        update(currentProducts, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        }),
      );
    },
    [currentProducts, handleUpdateProducts],
  );

  return (
    <Fragment>
      <div className="bootstrap-table">
        <div className="fixed-table-container">
          <div className="fixed-table-body">
            <table className="table table-centered">
              <thead className="thead-light">
                <tr>
                  <th style={{ width: '41px' }}></th>
                  <th style={{ width: '76px' }}></th>
                  <th>Наименование</th>
                  <th></th>
                </tr>
              </thead>
              <DndProvider backend={Backend}>
                <tbody>
                  {currentProducts
                    .sort((a, b) =>
                      parseInt(a).collectionPos < parseInt(b).collectionPos ? -1 : 1,
                    )
                    .map((data, index) => (
                      <Product
                        key={index.toString()}
                        data={data}
                        index={index}
                        moveFilter={moveFilter}
                        handleRemoveProduct={handleRemoveProduct}
                        handleUpdateProducts={handleUpdateProducts}
                        currentProducts={currentProducts}
                      />
                    ))}
                </tbody>
              </DndProvider>
            </table>
          </div>
        </div>
      </div>
      {/* <Pagination /> */}
      <button
        type="button"
        className="btn btn-light waves-effect waves-light mr-2"
        onClick={handleAddProducts}
      >
        Добавить товары
      </button>
    </Fragment>
  );
};

export default ManualItems;
